"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _IntegrationSetup = _interopRequireDefault(require("./IntegrationSetup"));

var _axios = _interopRequireDefault(require("axios"));

var _PanelItems = require("./components/PanelItems");

var _UninstallModal = _interopRequireDefault(require("./components/UninstallModal"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _common = require("@insided/shared/utils/common");

var _SalesforceLanguages = _interopRequireDefault(require("./assets/SalesforceLanguages"));

var _Tabs = require("./components/salesforce/Tabs");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _Warning = _interopRequireDefault(require("@insided/shared/icons/Warning"));

var _Forbidden = _interopRequireDefault(require("@insided/control/icons/Forbidden"));

var _constants = require("@insided/shared/constants");

var _companyMappingHistory = _interopRequireDefault(require("@insided/control/modules/Core/company-mapping-history"));

var _companyMapping = _interopRequireDefault(require("@insided/control/modules/Core/company-mapping"));

var _salesforceCompanyMappingApi = require("@insided/control/modules/Core/company-mapping/salesforceCompanyMappingApi");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SalesforceIntegration = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SalesforceIntegration, _Component);

  var _super = _createSuper(SalesforceIntegration);

  function SalesforceIntegration(props) {
    var _props$isInstalled, _props$caseEscalation, _props$federatedSearc, _props$federatedSearc2, _props$channel, _props$crmEnabled, _props$syncAccountDat, _props$syncAccountDat2, _props$type, _props$username, _props$instanceUrl$re, _props$instanceUrl, _props$appConsumerKey, _props$isOauthEnabled, _props$channel2, _props$type2, _props$username2, _props$instanceUrl$re2, _props$instanceUrl2, _props$appConsumerKey2, _props$isOauthEnabled2, _props$caseEscalation2, _props$federatedSearc3, _props$federatedSearc4, _props$crmEnabled2, _props$syncAccountDat3, _props$syncAccountDat4;

    var _this;

    (0, _classCallCheck2.default)(this, SalesforceIntegration);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchCompanyMappingConfigWithErrorHandling", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(errorMessage) {
        var config;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _salesforceCompanyMappingApi.fetchCompanyMappingConfig)();

              case 3:
                config = _context.sent;

                _this.setState({
                  companyMappingConfig: config
                });

                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                _logger.logger.error(_context.t0, {
                  component: 'SalesforceIntegrationV2',
                  action: 'fetchCompanyMappingConfig'
                });

                _this.setState({
                  messageType: 'error',
                  message: errorMessage || 'Error loading company mapping data, please refresh or try again later.'
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refreshCompanyMappingConfig", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.fetchCompanyMappingConfigWithErrorHandling('Error refreshing company mapping data, please refresh or try again later.');

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    _this.state = {
      isInstalled: (_props$isInstalled = props.isInstalled) !== null && _props$isInstalled !== void 0 ? _props$isInstalled : false,
      isCaseCreationEnabled: (_props$caseEscalation = props.caseEscalationEnabled) !== null && _props$caseEscalation !== void 0 ? _props$caseEscalation : false,
      showCaseCreationActionButtons: false,
      isFederatedSearchEnabled: (_props$federatedSearc = props.federatedSearchEnabled) !== null && _props$federatedSearc !== void 0 ? _props$federatedSearc : false,
      federatedSearchLocale: _this.getFederatedSearchLocale((_props$federatedSearc2 = props.federatedSearchLanguage) !== null && _props$federatedSearc2 !== void 0 ? _props$federatedSearc2 : ''),
      federatedSearchCustomDomain: props.knowledgeBaseDomain,
      federatedSearchChannel: (_props$channel = props.channel) !== null && _props$channel !== void 0 ? _props$channel : 'Pkb',
      isFederatedSearchCustomDomainEnabled: !!props.knowledgeBaseDomain,
      showFederatedSearchActionButtons: false,
      federatedSearchInitialSyncCompleted: false,
      isCrmExportEnabled: (_props$crmEnabled = props.crmEnabled) !== null && _props$crmEnabled !== void 0 ? _props$crmEnabled : false,
      crmImportMappingData: (_props$syncAccountDat = props.syncAccountDataMapping) !== null && _props$syncAccountDat !== void 0 ? _props$syncAccountDat : _this.createDefaultCrmImportMapping(),
      showCrmExportActionButtons: false,
      isCrmImportEnabled: (_props$syncAccountDat2 = props.syncAccountDataEnabled) !== null && _props$syncAccountDat2 !== void 0 ? _props$syncAccountDat2 : false,
      showCrmImportActionButtons: false,
      type: (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : '',
      username: (_props$username = props.username) !== null && _props$username !== void 0 ? _props$username : '',
      instanceUrl: (_props$instanceUrl$re = (_props$instanceUrl = props.instanceUrl) === null || _props$instanceUrl === void 0 ? void 0 : _props$instanceUrl.replace('.salesforce.com', '')) !== null && _props$instanceUrl$re !== void 0 ? _props$instanceUrl$re : '',
      appConsumerKey: (_props$appConsumerKey = props.appConsumerKey) !== null && _props$appConsumerKey !== void 0 ? _props$appConsumerKey : '',
      isOauthEnabled: (_props$isOauthEnabled = props.isOauthEnabled) !== null && _props$isOauthEnabled !== void 0 ? _props$isOauthEnabled : true,
      activeTab: 0,
      showUnsavedChangesModal: false,
      showUninstallModal: false,
      storedState: {
        federatedSearchCustomDomain: props.knowledgeBaseDomain,
        federatedSearchChannel: (_props$channel2 = props.channel) !== null && _props$channel2 !== void 0 ? _props$channel2 : 'Pkb',
        isFederatedSearchCustomDomainEnabled: !!props.knowledgeBaseDomain,
        type: (_props$type2 = props.type) !== null && _props$type2 !== void 0 ? _props$type2 : '',
        username: (_props$username2 = props.username) !== null && _props$username2 !== void 0 ? _props$username2 : '',
        instanceUrl: (_props$instanceUrl$re2 = (_props$instanceUrl2 = props.instanceUrl) === null || _props$instanceUrl2 === void 0 ? void 0 : _props$instanceUrl2.replace('.salesforce.com', '')) !== null && _props$instanceUrl$re2 !== void 0 ? _props$instanceUrl$re2 : '',
        appConsumerKey: (_props$appConsumerKey2 = props.appConsumerKey) !== null && _props$appConsumerKey2 !== void 0 ? _props$appConsumerKey2 : '',
        isOauthEnabled: (_props$isOauthEnabled2 = props.isOauthEnabled) !== null && _props$isOauthEnabled2 !== void 0 ? _props$isOauthEnabled2 : true,
        isCaseCreationEnabled: (_props$caseEscalation2 = props.caseEscalationEnabled) !== null && _props$caseEscalation2 !== void 0 ? _props$caseEscalation2 : false,
        isFederatedSearchEnabled: (_props$federatedSearc3 = props.federatedSearchEnabled) !== null && _props$federatedSearc3 !== void 0 ? _props$federatedSearc3 : false,
        federatedSearchLocale: _this.getFederatedSearchLocale((_props$federatedSearc4 = props.federatedSearchLanguage) !== null && _props$federatedSearc4 !== void 0 ? _props$federatedSearc4 : ''),
        isCrmExportEnabled: (_props$crmEnabled2 = props.crmEnabled) !== null && _props$crmEnabled2 !== void 0 ? _props$crmEnabled2 : false,
        isCrmImportEnabled: (_props$syncAccountDat3 = props.syncAccountDataEnabled) !== null && _props$syncAccountDat3 !== void 0 ? _props$syncAccountDat3 : false,
        crmImportMappingData: (_props$syncAccountDat4 = props.syncAccountDataMapping) !== null && _props$syncAccountDat4 !== void 0 ? _props$syncAccountDat4 : _this.createDefaultCrmImportMapping()
      },
      messageType: undefined
    };
    _this.setActiveTab = _this.setActiveTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.dismissMessage = _this.dismissMessage.bind((0, _assertThisInitialized2.default)(_this));
    _this.setSelectedPanel = _this.setSelectedPanel.bind((0, _assertThisInitialized2.default)(_this));
    _this.setActivePanel = _this.setActivePanel.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetActivePanel = _this.resetActivePanel.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickUninstallButton = _this.onClickUninstallButton.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeUninstallModal = _this.closeUninstallModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeModal = _this.closeModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.displayUnsavedChangedModal = _this.displayUnsavedChangedModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.onInstall = _this.onInstall.bind((0, _assertThisInitialized2.default)(_this));
    _this.showInstallationStatusOnPageLoad = _this.showInstallationStatusOnPageLoad.bind((0, _assertThisInitialized2.default)(_this));
    _this.onUninstall = _this.onUninstall.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetIntegrationPanelChanges = _this.resetIntegrationPanelChanges.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveCaseCreationSetting = _this.saveCaseCreationSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCaseCreationSettingChanged = _this.onCaseCreationSettingChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetCaseCreationSetting = _this.resetCaseCreationSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveCrmExportSetting = _this.saveCrmExportSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCrmExportSettingChanged = _this.onCrmExportSettingChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetCrmExportSetting = _this.resetCrmExportSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveCrmImportSetting = _this.saveCrmImportSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCrmImportSettingChanged = _this.onCrmImportSettingChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetCrmImportSetting = _this.resetCrmImportSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.onFederatedSearchSettingChanged = _this.onFederatedSearchSettingChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetFederatedSearchSetting = _this.resetFederatedSearchSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveFederatedSearchSetting = _this.saveFederatedSearchSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.onFederatedSearchLocaleClicked = _this.onFederatedSearchLocaleClicked.bind((0, _assertThisInitialized2.default)(_this));
    _this.onFederatedSearchDomainClicked = _this.onFederatedSearchDomainClicked.bind((0, _assertThisInitialized2.default)(_this));
    _this.toggleCustomDomainField = _this.toggleCustomDomainField.bind((0, _assertThisInitialized2.default)(_this));
    _this.setCustomDomainField = _this.setCustomDomainField.bind((0, _assertThisInitialized2.default)(_this));
    _this.setChannelField = _this.setChannelField.bind((0, _assertThisInitialized2.default)(_this));
    _this.isValidHttpUrl = _this.isValidHttpUrl.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(SalesforceIntegration, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var _this2 = this;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({
                  messageType: undefined
                });
                window.addEventListener('beforeunload', function (e) {
                  return _this2.onUnload(e);
                });
                this.showInstallationStatusOnPageLoad(); // Only fetch company mapping config if Salesforce app is installed, CRM export is enabled, and feature flag is active

                if (this.state.isInstalled && this.state.storedState.isCrmExportEnabled && _common.common.isModuleActive('resolveSFDCMapping')) {
                  this.fetchCompanyMappingConfigWithErrorHandling('Error loading company mapping and history tabs, please refresh or try again later.');
                }

                this.setState({
                  moderatorId: (0, _insidedDataStorage.getInsidedData)('user').userid
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "showInstallationStatusOnPageLoad",
    value: function showInstallationStatusOnPageLoad() {
      var type = this.state.type;
      var formattedUrl = window.location.href.split('?')[0];

      if (window.location.search.includes('?status=success')) {
        this.setState({
          messageType: 'success',
          message: 'All set! Salesforce installed.'
        });

        _publish.default.trackEvent('userevent', {
          type: 'Salesforce app installed',
          instance_type: type
        });

        window.history.pushState(null, 'SF installation success', formattedUrl);
      }

      if (window.location.search.includes('?status=cancelled')) {
        window.history.pushState(null, 'SF installation cancelled', formattedUrl);
        this.setState({
          messageType: 'error',
          message: 'Authorization Failed'
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', this.onUnload);
    }
  }, {
    key: "onUnload",
    value: function onUnload(e) {
      if (this.checkPanelHasUnsavedChanges()) {
        e.preventDefault();
        e.returnValue = '';
      }
    }
  }, {
    key: "createDefaultCrmImportMapping",
    value: function createDefaultCrmImportMapping() {
      return {
        fieldApiName: '',
        valueApiName: []
      };
    }
  }, {
    key: "isValidHttpUrl",
    value: function isValidHttpUrl(urlToCheck) {
      var regex = /^((https?|s?ftp):\/\/)(?:([\w-]+)\.)?([\w-]+)\.([\w]+)\/?(?:([^?#$]+))?(?:\?([^#$]+))?(?:#(.*))?$/;
      return regex.test(urlToCheck);
    }
  }, {
    key: "getFederatedSearchLocale",
    value: function getFederatedSearchLocale(federatedSearchLanguage) {
      if (federatedSearchLanguage === '') {
        return null;
      }

      return {
        value: federatedSearchLanguage,
        title: _SalesforceLanguages.default.filter(function (salesforceLanguage) {
          return salesforceLanguage.value === federatedSearchLanguage;
        })[0].title
      };
    }
  }, {
    key: "toggleCustomDomainField",
    value: function toggleCustomDomainField(status) {
      this.setState({
        isFederatedSearchCustomDomainEnabled: status,
        showFederatedSearchActionButtons: true
      });
    }
  }, {
    key: "setCustomDomainField",
    value: function setCustomDomainField(domain) {
      this.setState({
        federatedSearchCustomDomain: domain,
        showFederatedSearchActionButtons: true
      });
    }
  }, {
    key: "setChannelField",
    value: function setChannelField(channel) {
      this.setState({
        federatedSearchChannel: channel,
        showFederatedSearchActionButtons: true
      });
    }
  }, {
    key: "onClickUninstallButton",
    value: function onClickUninstallButton() {
      this.setState({
        showUninstallModal: true
      });
    }
  }, {
    key: "closeUninstallModal",
    value: function closeUninstallModal() {
      this.setState({
        showUninstallModal: false
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        showUnsavedChangesModal: false
      });
    }
  }, {
    key: "checkPanelHasUnsavedChanges",
    value: function checkPanelHasUnsavedChanges() {
      var _this$state = this.state,
          isCrmExportEnabled = _this$state.isCrmExportEnabled,
          isCaseCreationEnabled = _this$state.isCaseCreationEnabled,
          storedState = _this$state.storedState,
          type = _this$state.type;
      var hasCrmExportSettingChanged = isCrmExportEnabled !== storedState.isCrmExportEnabled;
      var hasCaseCreationSettingChanged = isCaseCreationEnabled !== storedState.isCaseCreationEnabled;
      var hasInstanceTypeChanged = type !== storedState.type;
      var hasCrmImportChanged = this.checkCrmImportPanelHasUnsavedChanges();
      var hasFederatedSearchChanged = this.checkFederatedSearchPanelHasUnsavedChanges();
      return hasCrmExportSettingChanged || hasCaseCreationSettingChanged || hasInstanceTypeChanged || hasCrmImportChanged || hasFederatedSearchChanged;
    }
  }, {
    key: "checkCrmImportPanelHasUnsavedChanges",
    value: function checkCrmImportPanelHasUnsavedChanges() {
      var _this$state2 = this.state,
          isCrmImportEnabled = _this$state2.isCrmImportEnabled,
          crmImportMappingData = _this$state2.crmImportMappingData,
          storedState = _this$state2.storedState;
      var hasValueApiNameChanged = JSON.stringify(crmImportMappingData.valueApiName) !== JSON.stringify(storedState.crmImportMappingData.valueApiName);
      var hasFieldApiNameChanged = crmImportMappingData.fieldApiName !== storedState.crmImportMappingData.fieldApiName;
      var hasCrmImportSettingChanged = isCrmImportEnabled !== storedState.isCrmImportEnabled;
      return hasCrmImportSettingChanged || hasValueApiNameChanged || hasFieldApiNameChanged;
    }
  }, {
    key: "checkFederatedSearchPanelHasUnsavedChanges",
    value: function checkFederatedSearchPanelHasUnsavedChanges() {
      var _storedState$federate;

      var _this$state3 = this.state,
          isFederatedSearchEnabled = _this$state3.isFederatedSearchEnabled,
          federatedSearchLocale = _this$state3.federatedSearchLocale,
          isFederatedSearchCustomDomainEnabled = _this$state3.isFederatedSearchCustomDomainEnabled,
          federatedSearchCustomDomain = _this$state3.federatedSearchCustomDomain,
          federatedSearchChannel = _this$state3.federatedSearchChannel,
          storedState = _this$state3.storedState;
      var hasFederatedSearchLocaleChanged = (federatedSearchLocale === null || federatedSearchLocale === void 0 ? void 0 : federatedSearchLocale.value) !== ((_storedState$federate = storedState.federatedSearchLocale) === null || _storedState$federate === void 0 ? void 0 : _storedState$federate.value);
      var hasFederatedSearchSettingChanged = isFederatedSearchEnabled !== storedState.isFederatedSearchEnabled;
      var hasFederatedSearchDomainSettingChanged = isFederatedSearchCustomDomainEnabled !== storedState.isFederatedSearchCustomDomainEnabled;
      var hasFederatedSearchDomainChanged = federatedSearchCustomDomain !== storedState.federatedSearchCustomDomain;
      var hasFederatedSearchChannelChanged = federatedSearchChannel !== storedState.federatedSearchChannel;
      return hasFederatedSearchSettingChanged || hasFederatedSearchLocaleChanged || hasFederatedSearchDomainSettingChanged || hasFederatedSearchDomainChanged || hasFederatedSearchChannelChanged;
    }
  }, {
    key: "setActiveTab",
    value: function setActiveTab(selectedTab) {
      if (this.checkPanelHasUnsavedChanges()) {
        this.setState({
          showUnsavedChangesModal: true,
          selectedTab: selectedTab
        });
        return;
      }

      this.setState({
        activeTab: selectedTab,
        selectedTab: selectedTab
      });
    }
  }, {
    key: "displayUnsavedChangedModal",
    value: function displayUnsavedChangedModal() {
      this.setState({
        showUnsavedChangesModal: true
      });
    }
  }, {
    key: "resetActivePanel",
    value: function resetActivePanel() {
      this.setState({
        activePanel: undefined
      });
    }
  }, {
    key: "successMessage",
    value: function successMessage() {
      return 'Changes are saved successfully.';
    }
  }, {
    key: "errorMessage",
    value: function errorMessage() {
      return 'Sorry, something went wrong, please try again.';
    }
  }, {
    key: "enabledIntegrationCount",
    value: function enabledIntegrationCount() {
      var storedState = this.state.storedState;
      var count = 0;

      if (storedState.isFederatedSearchEnabled) {
        count++;
      }

      if (storedState.isCaseCreationEnabled) {
        count++;
      }

      if (storedState.isCrmExportEnabled) {
        count++;
      }

      if (storedState.isCrmImportEnabled) {
        count++;
      }

      return count;
    }
  }, {
    key: "setSelectedPanel",
    value: function setSelectedPanel(selectedPanel) {
      this.setState({
        selectedPanel: selectedPanel
      });
    }
  }, {
    key: "removeValidationErrorFromInputField",
    value: function removeValidationErrorFromInputField(inputField) {
      var errorFields = this.state.errorFields;

      if ((errorFields === null || errorFields === void 0 ? void 0 : errorFields.length) === 0) {
        return;
      }

      var fields = errorFields === null || errorFields === void 0 ? void 0 : errorFields.filter(function (value) {
        return value.field !== inputField;
      });
      this.setState({
        errorFields: fields
      });
    }
  }, {
    key: "onUninstall",
    value: function () {
      var _onUninstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var errorMessage, successMessage, updatedStoredState;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.setState({
                  messageType: undefined
                });
                errorMessage = 'Unable to delete credentials for salesforce integration.';
                successMessage = "You've uninstalled Salesforce.";
                _context4.prev = 3;
                _context4.next = 6;
                return _axios.default.delete('/integration/salesforce/settings');

              case 6:
                updatedStoredState = _objectSpread({}, this.state.storedState);
                updatedStoredState.isOauthEnabled = true;
                updatedStoredState.username = '';
                updatedStoredState.instanceUrl = '';
                updatedStoredState.appConsumerKey = '';
                updatedStoredState.type = '';
                updatedStoredState.isCrmImportEnabled = false;
                updatedStoredState.isFederatedSearchEnabled = false;
                updatedStoredState.federatedSearchLocale = this.getFederatedSearchLocale('');
                updatedStoredState.isCrmExportEnabled = false;
                updatedStoredState.isCaseCreationEnabled = false;
                updatedStoredState.crmImportMappingData = this.createDefaultCrmImportMapping();
                this.setState({
                  storedState: updatedStoredState,
                  showUninstallModal: false,
                  isInstalled: false,
                  // Only reset activeTab if user is on Company Mapping (2) or History (3) tabs that will disappear
                  // Keep current tab if user is on Integration (0) or Installation (1) tabs that remain available
                  activeTab: this.state.activeTab >= 2 ? 0 : this.state.activeTab,
                  companyMappingConfig: undefined,
                  // Clear mapping config since app is uninstalled
                  instanceUrl: '',
                  username: '',
                  appConsumerKey: '',
                  type: '',
                  isOauthEnabled: true,
                  isCrmImportEnabled: false,
                  crmImportMappingData: this.createDefaultCrmImportMapping(),
                  isFederatedSearchEnabled: false,
                  federatedSearchLocale: this.getFederatedSearchLocale(''),
                  isFederatedSearchCustomDomainEnabled: false,
                  federatedSearchCustomDomain: '',
                  federatedSearchChannel: 'Pkb',
                  isCrmExportEnabled: false,
                  isCaseCreationEnabled: false,
                  messageType: 'success',
                  message: successMessage,
                  errorFields: []
                });
                _context4.next = 24;
                break;

              case 21:
                _context4.prev = 21;
                _context4.t0 = _context4["catch"](3);
                this.setState({
                  messageType: 'error',
                  message: errorMessage
                });

              case 24:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 21]]);
      }));

      function onUninstall() {
        return _onUninstall.apply(this, arguments);
      }

      return onUninstall;
    }()
  }, {
    key: "onInstall",
    value: function () {
      var _onInstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var type, updatedState, response, url;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                type = this.state.type || (this.props.isProduction ? 'Production' : 'Sandbox');
                updatedState = _objectSpread({}, this.state.storedState);
                updatedState.type = type;
                this.setState({
                  storedState: updatedState
                });
                _context5.next = 6;
                return _axios.default.post('/integration/salesforce/authorize', {
                  type: type
                });

              case 6:
                response = _context5.sent;
                url = response.data.url;

                if (url) {
                  window.open(url, '_blank', 'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=800,height=600');
                }

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function onInstall() {
        return _onInstall.apply(this, arguments);
      }

      return onInstall;
    }()
  }, {
    key: "onResetInstallationTab",
    value: function onResetInstallationTab() {
      var _this$state4 = this.state,
          selectedTab = _this$state4.selectedTab,
          activeTab = _this$state4.activeTab,
          storedState = _this$state4.storedState;
      this.setState({
        type: storedState.type
      });

      if (selectedTab !== undefined && selectedTab !== activeTab) {
        this.setState({
          activeTab: selectedTab,
          showUnsavedChangesModal: false
        });
      } else {
        this.setState({
          showUnsavedChangesModal: false
        });
      }
    }
  }, {
    key: "resetIntegrationPanelChanges",
    value: function resetIntegrationPanelChanges() {
      this.resetActivePanel();
      var _this$state5 = this.state,
          isCaseCreationEnabled = _this$state5.isCaseCreationEnabled,
          isCrmExportEnabled = _this$state5.isCrmExportEnabled,
          type = _this$state5.type,
          storedState = _this$state5.storedState,
          selectedTab = _this$state5.selectedTab,
          activeTab = _this$state5.activeTab;

      if (isCaseCreationEnabled !== storedState.isCaseCreationEnabled) {
        this.resetCaseCreationSetting(true);
      }

      if (isCrmExportEnabled !== storedState.isCrmExportEnabled) {
        this.resetCrmExportSetting(true);
      }

      if (this.checkCrmImportPanelHasUnsavedChanges()) {
        this.resetCrmImportSetting(true);
      }

      if (this.checkFederatedSearchPanelHasUnsavedChanges()) {
        this.resetFederatedSearchSetting(true);
      }

      if (type !== storedState.type) {
        this.setState({
          type: storedState.type
        });
      }

      if (selectedTab !== undefined && selectedTab !== activeTab) {
        this.setState({
          activeTab: selectedTab,
          showUnsavedChangesModal: false
        });
      } else {
        this.setState({
          showUnsavedChangesModal: false
        });
      }
    }
  }, {
    key: "saveCrmImportSetting",
    value: function () {
      var _saveCrmImportSetting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        var _this$state6, isCrmImportEnabled, crmImportMappingData, fieldApiName, valueApiName, validatedFields, hasFieldNameError, hasValueApiNameError, updatedState, _isCrmImportEnabled;

        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  errorFields: [],
                  isSavingCrmImportSetting: true
                });
                _this$state6 = this.state, isCrmImportEnabled = _this$state6.isCrmImportEnabled, crmImportMappingData = _this$state6.crmImportMappingData;
                fieldApiName = crmImportMappingData.fieldApiName, valueApiName = crmImportMappingData.valueApiName;
                validatedFields = [];
                hasFieldNameError = isCrmImportEnabled && (!fieldApiName || fieldApiName.length === 0);
                hasValueApiNameError = isCrmImportEnabled && (!valueApiName || valueApiName.length === 0);

                if (hasFieldNameError) {
                  validatedFields.push({
                    field: 'fieldApiName',
                    message: 'Please fill in the required field.'
                  });
                }

                if (hasValueApiNameError) {
                  validatedFields.push({
                    field: 'valueApiName',
                    message: 'Please fill in the required field.'
                  });
                }

                if (!(validatedFields.length !== 0)) {
                  _context6.next = 11;
                  break;
                }

                this.setState({
                  errorFields: validatedFields,
                  isSavingCrmImportSetting: false
                });
                return _context6.abrupt("return");

              case 11:
                _context6.prev = 11;
                _context6.next = 14;
                return _axios.default.post('/integration/salesforce/syncAccountDataSettings', {
                  syncAccountData: isCrmImportEnabled,
                  syncAccountMappingData: crmImportMappingData
                });

              case 14:
                updatedState = _objectSpread({}, this.state.storedState);
                updatedState.isCrmImportEnabled = isCrmImportEnabled;
                updatedState.crmImportMappingData = crmImportMappingData;
                this.setState({
                  showCrmImportActionButtons: false,
                  isSavingCrmImportSetting: false,
                  storedState: updatedState,
                  messageType: 'success',
                  message: this.successMessage(),
                  errorFields: []
                });

                _publish.default.trackEvent('userevent', {
                  type: "Import Salesforce Account data to ".concat(_constants.PLATFORM_BRAND_NAME, " ").concat(isCrmImportEnabled ? 'enabled' : 'disabled')
                });

                _context6.next = 25;
                break;

              case 21:
                _context6.prev = 21;
                _context6.t0 = _context6["catch"](11);
                _isCrmImportEnabled = this.state.storedState.isCrmImportEnabled;
                this.setState({
                  messageType: 'error',
                  message: this.errorMessage(),
                  isCrmImportEnabled: _isCrmImportEnabled,
                  showCrmImportActionButtons: false,
                  isSavingCrmImportSetting: false,
                  errorFields: []
                });

              case 25:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[11, 21]]);
      }));

      function saveCrmImportSetting() {
        return _saveCrmImportSetting.apply(this, arguments);
      }

      return saveCrmImportSetting;
    }()
  }, {
    key: "onCrmImportSettingChanged",
    value: function onCrmImportSettingChanged(value) {
      this.setState({
        isCrmImportEnabled: value,
        showCrmImportActionButtons: true,
        errorFields: []
      });
    }
  }, {
    key: "resetCrmImportSetting",
    value: function resetCrmImportSetting() {
      var isDiscardButtonClicked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var storedState = this.state.storedState;
      this.setState({
        isCrmImportEnabled: storedState.isCrmImportEnabled,
        crmImportMappingData: storedState.crmImportMappingData,
        showCrmImportActionButtons: false,
        showUnsavedChangesModal: false,
        errorFields: []
      });

      if (isDiscardButtonClicked) {
        this.setActivePanel();
      }
    }
  }, {
    key: "onCrmImportMappingFieldApiNameChanged",
    value: function onCrmImportMappingFieldApiNameChanged(value) {
      var updatedFieldApiName = value.trim();
      var fieldApiName = this.state.crmImportMappingData.fieldApiName;

      if (updatedFieldApiName !== fieldApiName) {
        this.setState({
          crmImportMappingData: {
            fieldApiName: updatedFieldApiName,
            valueApiName: []
          },
          showCrmImportActionButtons: true
        });
      }
    }
  }, {
    key: "onCrmImportMappingPicklistValueChanged",
    value: function onCrmImportMappingPicklistValueChanged(value) {
      var fieldApiName = this.state.crmImportMappingData.fieldApiName;
      this.setState({
        crmImportMappingData: {
          fieldApiName: fieldApiName,
          valueApiName: value
        },
        showCrmImportActionButtons: true
      });
    }
  }, {
    key: "saveCaseCreationSetting",
    value: function () {
      var _saveCaseCreationSetting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
        var isCaseCreationEnabled, updatedState;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  isSavingCaseCreationSetting: true
                });
                isCaseCreationEnabled = this.state.isCaseCreationEnabled;
                _context7.prev = 2;
                _context7.next = 5;
                return _axios.default.post('/integration/salesforce/toggleCaseEscalation', {
                  caseEscalationEnabled: isCaseCreationEnabled
                });

              case 5:
                updatedState = _objectSpread({}, this.state.storedState);
                updatedState.isCaseCreationEnabled = isCaseCreationEnabled;
                this.setState({
                  isCaseCreationEnabled: isCaseCreationEnabled,
                  storedState: updatedState,
                  message: this.successMessage(),
                  messageType: 'success',
                  showCaseCreationActionButtons: false,
                  isSavingCaseCreationSetting: false
                });

                _publish.default.trackEvent('userevent', {
                  type: "Create Salesforce cases from community posts ".concat(isCaseCreationEnabled ? 'enabled' : 'disabled')
                });

                _context7.next = 14;
                break;

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](2);
                this.setState({
                  messageType: 'error',
                  message: this.errorMessage(),
                  showCaseCreationActionButtons: false,
                  isSavingCaseCreationSetting: false,
                  isCaseCreationEnabled: this.state.storedState.isCaseCreationEnabled
                });

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[2, 11]]);
      }));

      function saveCaseCreationSetting() {
        return _saveCaseCreationSetting.apply(this, arguments);
      }

      return saveCaseCreationSetting;
    }()
  }, {
    key: "onCaseCreationSettingChanged",
    value: function onCaseCreationSettingChanged(value) {
      this.setState({
        isCaseCreationEnabled: value,
        showCaseCreationActionButtons: true
      });
    }
  }, {
    key: "resetCaseCreationSetting",
    value: function resetCaseCreationSetting() {
      var isDiscardButton = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var storedState = this.state.storedState;
      this.setState({
        isCaseCreationEnabled: storedState.isCaseCreationEnabled,
        showCaseCreationActionButtons: false,
        showUnsavedChangesModal: false
      });

      if (isDiscardButton) {
        this.setActivePanel();
      }
    }
  }, {
    key: "saveCrmExportSetting",
    value: function () {
      var _saveCrmExportSetting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
        var isCrmExportEnabled, updatedState;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  isSavingCrmExportSetting: true
                });
                isCrmExportEnabled = this.state.isCrmExportEnabled;
                _context8.prev = 2;
                _context8.next = 5;
                return _axios.default.post('/integration/salesforce/toggleCRM', {
                  isActive: isCrmExportEnabled
                });

              case 5:
                updatedState = _objectSpread({}, this.state.storedState);
                updatedState.isCrmExportEnabled = isCrmExportEnabled;
                this.setState({
                  isCrmExportEnabled: isCrmExportEnabled,
                  storedState: updatedState,
                  message: this.successMessage(),
                  messageType: 'success',
                  showCrmExportActionButtons: false,
                  isSavingCrmExportSetting: false
                }); // Fetch company mapping config when CRM export is enabled and all conditions are met

                if (isCrmExportEnabled && this.state.isInstalled && _common.common.isModuleActive('resolveSFDCMapping')) {
                  this.fetchCompanyMappingConfigWithErrorHandling();
                }

                _publish.default.trackEvent('userevent', {
                  type: "Export community member & activity data to Salesforce ".concat(isCrmExportEnabled ? 'enabled' : 'disabled')
                });

                _context8.next = 15;
                break;

              case 12:
                _context8.prev = 12;
                _context8.t0 = _context8["catch"](2);
                this.setState({
                  messageType: 'error',
                  message: this.errorMessage(),
                  showCrmExportActionButtons: false,
                  isSavingCrmExportSetting: false,
                  isCrmExportEnabled: this.state.storedState.isCrmExportEnabled
                });

              case 15:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[2, 12]]);
      }));

      function saveCrmExportSetting() {
        return _saveCrmExportSetting.apply(this, arguments);
      }

      return saveCrmExportSetting;
    }()
  }, {
    key: "onCrmExportSettingChanged",
    value: function onCrmExportSettingChanged(value) {
      this.setState({
        isCrmExportEnabled: value,
        showCrmExportActionButtons: true
      });
    }
  }, {
    key: "resetCrmExportSetting",
    value: function resetCrmExportSetting() {
      var isDiscardButton = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var storedState = this.state.storedState;
      this.setState({
        isCrmExportEnabled: storedState.isCrmExportEnabled,
        showCrmExportActionButtons: false,
        showUnsavedChangesModal: false
      });

      if (isDiscardButton) {
        this.setActivePanel();
      }
    }
  }, {
    key: "onFederatedSearchSettingChanged",
    value: function onFederatedSearchSettingChanged(value) {
      this.setState({
        isFederatedSearchEnabled: value,
        showFederatedSearchActionButtons: true
      });
    }
  }, {
    key: "resetFederatedSearchSetting",
    value: function resetFederatedSearchSetting() {
      var isDiscardButton = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var storedState = this.state.storedState;
      this.setState({
        isFederatedSearchEnabled: storedState.isFederatedSearchEnabled,
        federatedSearchLocale: storedState.federatedSearchLocale,
        federatedSearchCustomDomain: storedState.federatedSearchCustomDomain,
        federatedSearchChannel: storedState.federatedSearchChannel,
        isFederatedSearchCustomDomainEnabled: storedState.isFederatedSearchCustomDomainEnabled,
        errorFields: [],
        showFederatedSearchActionButtons: false,
        showUnsavedChangesModal: false
      });

      if (isDiscardButton) {
        this.setActivePanel();
      }
    }
  }, {
    key: "setActivePanel",
    value: function setActivePanel() {
      var selectedPanel = this.state.selectedPanel;
      this.setState({
        activePanel: selectedPanel
      });
    }
  }, {
    key: "dismissMessage",
    value: function dismissMessage() {
      this.setState({
        messageType: undefined,
        message: ''
      });
    }
  }, {
    key: "saveFederatedSearchSetting",
    value: function () {
      var _saveFederatedSearchSetting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
        var _this$state7, isFederatedSearchEnabled, federatedSearchLocale, isFederatedSearchCustomDomainEnabled, federatedSearchCustomDomain, federatedSearchChannel, validatedFields, response, successMessage, updatedState, _this$state$storedSta, _isFederatedSearchEnabled, _federatedSearchLocale, _isFederatedSearchCustomDomainEnabled, _federatedSearchCustomDomain, _federatedSearchChannel, err, errorMessage;

        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  isSavingFederatedSearchSetting: true
                });
                _this$state7 = this.state, isFederatedSearchEnabled = _this$state7.isFederatedSearchEnabled, federatedSearchLocale = _this$state7.federatedSearchLocale, isFederatedSearchCustomDomainEnabled = _this$state7.isFederatedSearchCustomDomainEnabled, federatedSearchCustomDomain = _this$state7.federatedSearchCustomDomain, federatedSearchChannel = _this$state7.federatedSearchChannel;
                validatedFields = [];

                if (isFederatedSearchEnabled && !federatedSearchLocale) {
                  validatedFields.push({
                    field: 'federatedSearchLanguage',
                    message: 'Please fill in the required field.'
                  });
                }

                if (isFederatedSearchCustomDomainEnabled) {
                  if (federatedSearchCustomDomain && !this.isValidHttpUrl(federatedSearchCustomDomain)) {
                    validatedFields.push({
                      field: 'knowledgeBaseDomain',
                      message: 'Invalid custom domain'
                    });
                  } else if (!federatedSearchCustomDomain) {
                    validatedFields.push({
                      field: 'knowledgeBaseDomain',
                      message: 'Please fill in the required field.'
                    });
                  }
                }

                if (!(validatedFields.length !== 0)) {
                  _context9.next = 8;
                  break;
                }

                this.setState({
                  errorFields: validatedFields,
                  isSavingFederatedSearchSetting: false
                });
                return _context9.abrupt("return");

              case 8:
                _context9.prev = 8;
                _context9.next = 11;
                return _axios.default.post('/integration/salesforce/toggleFederatedSearch', {
                  isActive: isFederatedSearchEnabled,
                  locale: federatedSearchLocale === null || federatedSearchLocale === void 0 ? void 0 : federatedSearchLocale.value,
                  domain: isFederatedSearchCustomDomainEnabled ? federatedSearchCustomDomain : '',
                  channel: federatedSearchChannel
                });

              case 11:
                response = _context9.sent;
                successMessage = isFederatedSearchEnabled ? "Federated search is enabled on your community. ".concat(response.data.count, " Salesforce articles are successfully synchronized!") : 'Changes are saved successfully.';
                updatedState = _objectSpread({}, this.state.storedState);
                updatedState.isFederatedSearchEnabled = isFederatedSearchEnabled;
                updatedState.federatedSearchLocale = federatedSearchLocale;
                updatedState.isFederatedSearchCustomDomainEnabled = isFederatedSearchCustomDomainEnabled;
                updatedState.federatedSearchCustomDomain = federatedSearchCustomDomain;
                updatedState.federatedSearchChannel = federatedSearchChannel;
                this.setState({
                  showFederatedSearchActionButtons: false,
                  isSavingFederatedSearchSetting: false,
                  storedState: updatedState,
                  messageType: 'success',
                  message: successMessage,
                  errorFields: [],
                  federatedSearchInitialSyncCompleted: true
                });

                _publish.default.trackEvent('userevent', {
                  type: "Salesforce federated search ".concat(isFederatedSearchEnabled ? 'enabled' : 'disabled')
                });

                _context9.next = 29;
                break;

              case 23:
                _context9.prev = 23;
                _context9.t0 = _context9["catch"](8);
                _this$state$storedSta = this.state.storedState, _isFederatedSearchEnabled = _this$state$storedSta.isFederatedSearchEnabled, _federatedSearchLocale = _this$state$storedSta.federatedSearchLocale, _isFederatedSearchCustomDomainEnabled = _this$state$storedSta.isFederatedSearchCustomDomainEnabled, _federatedSearchCustomDomain = _this$state$storedSta.federatedSearchCustomDomain, _federatedSearchChannel = _this$state$storedSta.federatedSearchChannel;
                err = _context9.t0.response.data;

                if (err === 'insufficient.permissions') {
                  errorMessage = 'Sorry, we cannot enable this integration because your Salesforce profile doesn’t have the “View Setup and Configuration” permission. Please check your permission settings or reinstall Salesforce using a different profile.';
                } else if (err === 'not.enabled.for.guests') {
                  errorMessage = 'Sorry, we cannot enable this integration because the knowledge base content is currently not enabled for Guest Users in your Salesforce instance.';
                } else {
                  errorMessage = this.errorMessage();
                }

                this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  showFederatedSearchActionButtons: false,
                  isSavingFederatedSearchSetting: false,
                  isFederatedSearchEnabled: _isFederatedSearchEnabled,
                  isFederatedSearchCustomDomainEnabled: _isFederatedSearchCustomDomainEnabled,
                  federatedSearchLocale: _federatedSearchLocale,
                  federatedSearchCustomDomain: _federatedSearchCustomDomain,
                  federatedSearchChannel: _federatedSearchChannel,
                  errorFields: [],
                  federatedSearchInitialSyncCompleted: false
                });

              case 29:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[8, 23]]);
      }));

      function saveFederatedSearchSetting() {
        return _saveFederatedSearchSetting.apply(this, arguments);
      }

      return saveFederatedSearchSetting;
    }()
  }, {
    key: "onFederatedSearchLocaleClicked",
    value: function onFederatedSearchLocaleClicked(locale) {
      this.setState({
        federatedSearchLocale: locale,
        showFederatedSearchActionButtons: true,
        errorFields: []
      });
    }
  }, {
    key: "onFederatedSearchDomainClicked",
    value: function onFederatedSearchDomainClicked(domain) {
      this.setState({
        federatedSearchCustomDomain: domain,
        showFederatedSearchActionButtons: true,
        errorFields: []
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var isProduction = this.props.isProduction;
      var _this$state8 = this.state,
          isInstalled = _this$state8.isInstalled,
          messageType = _this$state8.messageType,
          message = _this$state8.message,
          activeTab = _this$state8.activeTab,
          showUnsavedChangesModal = _this$state8.showUnsavedChangesModal,
          type = _this$state8.type,
          username = _this$state8.username,
          appConsumerKey = _this$state8.appConsumerKey,
          instanceUrl = _this$state8.instanceUrl,
          isOauthEnabled = _this$state8.isOauthEnabled,
          showUninstallModal = _this$state8.showUninstallModal,
          activePanel = _this$state8.activePanel,
          storedState = _this$state8.storedState,
          isCrmImportEnabled = _this$state8.isCrmImportEnabled,
          showCrmImportActionButtons = _this$state8.showCrmImportActionButtons,
          crmImportMappingData = _this$state8.crmImportMappingData,
          isFederatedSearchEnabled = _this$state8.isFederatedSearchEnabled,
          federatedSearchLocale = _this$state8.federatedSearchLocale,
          isFederatedSearchCustomDomainEnabled = _this$state8.isFederatedSearchCustomDomainEnabled,
          federatedSearchCustomDomain = _this$state8.federatedSearchCustomDomain,
          federatedSearchChannel = _this$state8.federatedSearchChannel,
          showFederatedSearchActionButtons = _this$state8.showFederatedSearchActionButtons,
          isCaseCreationEnabled = _this$state8.isCaseCreationEnabled,
          showCaseCreationActionButtons = _this$state8.showCaseCreationActionButtons,
          isCrmExportEnabled = _this$state8.isCrmExportEnabled,
          showCrmExportActionButtons = _this$state8.showCrmExportActionButtons,
          errorFields = _this$state8.errorFields,
          federatedSearchInitialSyncCompleted = _this$state8.federatedSearchInitialSyncCompleted,
          isSavingCrmImportSetting = _this$state8.isSavingCrmImportSetting,
          isSavingCrmExportSetting = _this$state8.isSavingCrmExportSetting,
          isSavingCaseCreationSetting = _this$state8.isSavingCaseCreationSetting,
          isSavingFederatedSearchSetting = _this$state8.isSavingFederatedSearchSetting,
          companyMappingConfig = _this$state8.companyMappingConfig,
          moderatorId = _this$state8.moderatorId;
      var instanceTypes = ['Sandbox', 'Production'];
      var panelHasUnsavedChanges = this.checkPanelHasUnsavedChanges();
      var enabledIntegrationCount = this.enabledIntegrationCount();

      var isCaseEscalationEnabled = _common.common.isModuleActive('salesforceCaseEscalation');

      var isCrmExportIntegrationEnabled = _common.common.isModuleActive('salesforceCrm');

      var isCrmImportIntegrationEnabled = _common.common.isModuleActive('salesforceSyncAccountData');

      var isFederatedSearchIntegrationEnabled = _common.common.isModuleActive('salesforceFederatedSearch');

      var isCompanyMappingEnabled = _common.common.isModuleActive('resolveSFDCMapping'); // Add setParentMessage function


      var setParentMessage = function setParentMessage(type, msg) {
        _this3.setState({
          messageType: type,
          message: msg
        });
      };

      return (0, _preact.h)(_IntegrationSetup.default, {
        headerTitle: "Salesforce",
        appLogoName: "salesforce-l",
        appContainerBackgroundColor: "#00A1E0",
        messageType: messageType,
        dismissMessage: this.dismissMessage,
        message: message,
        authStatusBanner: isInstalled ? (0, _preact.h)(AuthStatusBanner, {
          authCodeColor: this.props.authCodeColor,
          authStatusDescription: this.props.authStatusDescription
        }) : null,
        installButton: isInstalled ? (0, _preact.h)(_PanelItems.InstallAndUninstallButtons, {
          onClickUninstallButton: function onClickUninstallButton() {
            return _this3.onClickUninstallButton();
          }
        }) : (0, _preact.h)(_Button.default, {
          size: "medium",
          variant: "brand",
          title: "Install now",
          className: "installation__button_cta",
          onClick: function onClick() {
            return _this3.setActiveTab(1);
          }
        }),
        description: (0, _preact.h)(OverviewDescriptionText, null),
        tabTitles: isInstalled && storedState.isCrmExportEnabled && companyMappingConfig && isCompanyMappingEnabled ? ['Integration', 'Installation', 'Mapping', 'History'] : ['Integration', 'Installation'],
        activeTab: activeTab,
        onClickTab: function onClickTab(selectedTab) {
          return _this3.setActiveTab(selectedTab);
        },
        tabContents: [(0, _preact.h)(_Tabs.IntegrationTab, {
          key: "integrationTab",
          activePanel: activePanel,
          isInstalled: isInstalled,
          isProduction: isProduction,
          instanceType: type,
          hasUnsavedChanges: panelHasUnsavedChanges,
          showUnsavedChangesModal: showUnsavedChangesModal,
          displayUnsavedChangedModal: function displayUnsavedChangedModal() {
            return _this3.displayUnsavedChangedModal();
          },
          closeModal: function closeModal() {
            return _this3.closeModal();
          },
          resetChanges: function resetChanges() {
            return _this3.resetIntegrationPanelChanges();
          },
          storedState: storedState,
          onClickPanelCallback: function onClickPanelCallback(selectedPanel) {
            return _this3.setSelectedPanel(selectedPanel);
          },
          isCrmImportIntegrationEnabled: isCrmImportIntegrationEnabled,
          isCrmImportEnabled: isCrmImportEnabled,
          saveCrmImportSetting: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
            return _regenerator.default.wrap(function _callee10$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    _context10.next = 2;
                    return _this3.saveCrmImportSetting();

                  case 2:
                    return _context10.abrupt("return", _context10.sent);

                  case 3:
                  case "end":
                    return _context10.stop();
                }
              }
            }, _callee10);
          })),
          resetCrmImportSetting: function resetCrmImportSetting() {
            return _this3.resetCrmImportSetting();
          },
          onCrmImportSettingChanged: function onCrmImportSettingChanged() {
            return _this3.onCrmImportSettingChanged(!isCrmImportEnabled);
          },
          showCrmImportActionButtons: showCrmImportActionButtons,
          isSavingCrmImportSetting: isSavingCrmImportSetting,
          fieldApiName: crmImportMappingData.fieldApiName,
          valueApiName: crmImportMappingData.valueApiName,
          onCrmImportMappingFieldApiNameChanged: function onCrmImportMappingFieldApiNameChanged(value) {
            return _this3.onCrmImportMappingFieldApiNameChanged(value);
          },
          onCrmImportMappingPicklistValueChanged: function onCrmImportMappingPicklistValueChanged(value) {
            return _this3.onCrmImportMappingPicklistValueChanged(value);
          },
          isFederatedSearchIntegrationEnabled: isFederatedSearchIntegrationEnabled,
          isFederatedSearchEnabled: isFederatedSearchEnabled,
          isFederatedSearchCustomDomainEnabled: isFederatedSearchCustomDomainEnabled,
          federatedSearchInitialSyncCompleted: federatedSearchInitialSyncCompleted,
          showFederatedSearchActionButtons: showFederatedSearchActionButtons,
          isSavingFederatedSearchSetting: isSavingFederatedSearchSetting,
          federatedSearchLocale: federatedSearchLocale,
          federatedSearchCustomDomain: federatedSearchCustomDomain,
          federatedSearchChannel: federatedSearchChannel,
          toggleCustomDomainField: this.toggleCustomDomainField,
          setCustomDomainField: this.setCustomDomainField,
          setChannelField: this.setChannelField,
          saveFederatedSearchSetting: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11() {
            return _regenerator.default.wrap(function _callee11$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    _context11.next = 2;
                    return _this3.saveFederatedSearchSetting();

                  case 2:
                    return _context11.abrupt("return", _context11.sent);

                  case 3:
                  case "end":
                    return _context11.stop();
                }
              }
            }, _callee11);
          })),
          resetFederatedSearchSetting: function resetFederatedSearchSetting() {
            return _this3.resetFederatedSearchSetting();
          },
          onFederatedSearchSettingChanged: function onFederatedSearchSettingChanged() {
            return _this3.onFederatedSearchSettingChanged(!isFederatedSearchEnabled);
          },
          onFederatedSearchLocaleClicked: function onFederatedSearchLocaleClicked(locale) {
            return _this3.onFederatedSearchLocaleClicked(locale);
          },
          onFederatedSearchDomainClicked: this.onFederatedSearchDomainClicked,
          isCaseEscalationEnabled: isCaseEscalationEnabled,
          isCaseCreationEnabled: isCaseCreationEnabled,
          saveCaseCreationSetting: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12() {
            return _regenerator.default.wrap(function _callee12$(_context12) {
              while (1) {
                switch (_context12.prev = _context12.next) {
                  case 0:
                    _context12.next = 2;
                    return _this3.saveCaseCreationSetting();

                  case 2:
                    return _context12.abrupt("return", _context12.sent);

                  case 3:
                  case "end":
                    return _context12.stop();
                }
              }
            }, _callee12);
          })),
          resetCaseCreationSetting: function resetCaseCreationSetting() {
            return _this3.resetCaseCreationSetting();
          },
          onCaseCreationSettingChanged: function onCaseCreationSettingChanged() {
            return _this3.onCaseCreationSettingChanged(!isCaseCreationEnabled);
          },
          isSavingCaseCreationSetting: isSavingCaseCreationSetting,
          showCaseCreationActionButtons: showCaseCreationActionButtons,
          isCrmExportIntegrationEnabled: isCrmExportIntegrationEnabled,
          isCrmExportEnabled: isCrmExportEnabled,
          saveCrmExportSetting: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13() {
            return _regenerator.default.wrap(function _callee13$(_context13) {
              while (1) {
                switch (_context13.prev = _context13.next) {
                  case 0:
                    _context13.next = 2;
                    return _this3.saveCrmExportSetting();

                  case 2:
                    return _context13.abrupt("return", _context13.sent);

                  case 3:
                  case "end":
                    return _context13.stop();
                }
              }
            }, _callee13);
          })),
          resetCrmExportSetting: function resetCrmExportSetting() {
            return _this3.resetCrmExportSetting();
          },
          onCrmExportSettingChanged: function onCrmExportSettingChanged() {
            return _this3.onCrmExportSettingChanged(!isCrmExportEnabled);
          },
          showCrmExportActionButtons: showCrmExportActionButtons,
          isSavingCrmExportSetting: isSavingCrmExportSetting,
          errorFields: errorFields
        }), (0, _preact.h)(_Tabs.InstallationTab, {
          key: "installationTab",
          instanceTypes: instanceTypes,
          type: type !== null && type !== void 0 ? type : '',
          username: username,
          appConsumerKey: appConsumerKey,
          instanceUrl: instanceUrl,
          isOauthEnabled: isOauthEnabled,
          isInstalled: isInstalled,
          isProduction: isProduction,
          onSave: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14() {
            return _regenerator.default.wrap(function _callee14$(_context14) {
              while (1) {
                switch (_context14.prev = _context14.next) {
                  case 0:
                    _context14.next = 2;
                    return _this3.onInstall();

                  case 2:
                    return _context14.abrupt("return", _context14.sent);

                  case 3:
                  case "end":
                    return _context14.stop();
                }
              }
            }, _callee14);
          })),
          onClickManage: function onClickManage() {
            return _this3.setActiveTab(0);
          },
          onClickUninstall: function onClickUninstall() {
            return _this3.onClickUninstallButton();
          },
          onInstanceTypeChangeCallback: function onInstanceTypeChangeCallback(value) {
            return _this3.setState({
              type: value
            });
          },
          hasUnsavedChanges: panelHasUnsavedChanges,
          showUnsavedChangesModal: showUnsavedChangesModal,
          displayUnsavedChangedModal: function displayUnsavedChangedModal() {
            return _this3.displayUnsavedChangedModal();
          },
          closeModal: function closeModal() {
            return _this3.closeModal();
          },
          resetChanges: function resetChanges() {
            return _this3.onResetInstallationTab();
          }
        })].concat((0, _toConsumableArray2.default)(isInstalled && storedState.isCrmExportEnabled && companyMappingConfig && isCompanyMappingEnabled ? [(0, _preact.h)(_companyMapping.default, {
          key: "companyMappingUpload",
          moderatorId: moderatorId,
          chunkSize: companyMappingConfig.chunkSize,
          duplicateCompanyMappingsCount: companyMappingConfig.duplicateCompanyMappingsCount,
          setParentMessage: setParentMessage,
          onUploadStatusChanged: this.refreshCompanyMappingConfig,
          isDataBeingProcessed: companyMappingConfig.isDataBeingProcessed,
          history: companyMappingConfig.history || []
        }), (0, _preact.h)(_companyMappingHistory.default, {
          key: "companyMappingHistoryTab",
          history: companyMappingConfig.history || [],
          setParentMessage: setParentMessage
        })] : [])),
        uninstallModal: (0, _preact.h)(_UninstallModal.default, {
          headerTitle: "Salesforce",
          onUninstall: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15() {
            return _regenerator.default.wrap(function _callee15$(_context15) {
              while (1) {
                switch (_context15.prev = _context15.next) {
                  case 0:
                    _context15.next = 2;
                    return _this3.onUninstall();

                  case 2:
                    return _context15.abrupt("return", _context15.sent);

                  case 3:
                  case "end":
                    return _context15.stop();
                }
              }
            }, _callee15);
          })),
          showUninstallModal: showUninstallModal,
          closeUninstallModal: function closeUninstallModal() {
            return _this3.closeUninstallModal();
          },
          enabledIntegrationCount: enabledIntegrationCount,
          additionalText: "To fully remove the ".concat(_constants.PLATFORM_BRAND_NAME, " connected app\u2019s access to your Salesforce instance, please have a Salesforce administrator revoke the connected app from the Connected Apps OAuth Usage section of your Salesforce home setup.")
        })
      });
    }
  }]);
  return SalesforceIntegration;
}(_preact.Component);

var AuthStatusBanner = function AuthStatusBanner(_ref9) {
  var authCodeColor = _ref9.authCodeColor,
      authStatusDescription = _ref9.authStatusDescription;
  if (!authStatusDescription || !authCodeColor) return null;
  if (authCodeColor !== 'RED' && authCodeColor !== 'YELLOW') return null;
  var isError = authCodeColor === 'RED';
  var variant = isError ? 'error' : 'warning';
  return (0, _preact.h)("div", {
    className: "auth-status-banner auth-status-banner--".concat(variant)
  }, (0, _preact.h)("span", {
    className: "auth-status-banner__icon"
  }, isError ? (0, _preact.h)(_Forbidden.default, {
    width: 12,
    height: 12
  }) : (0, _preact.h)(_Warning.default, {
    width: 12,
    height: 12
  })), (0, _preact.h)("span", {
    className: "auth-status-banner__text"
  }, authStatusDescription));
};

var OverviewDescriptionText = function OverviewDescriptionText() {
  return (0, _preact.h)("div", null, "Salesforce is a customer relationship management solution that brings companies and customers together. It's one integrated CRM platform that gives all your departments \u2014 including marketing, sales, commerce, and service \u2014 a single, shared view of every customer.", (0, _preact.h)("div", {
    className: "description-details"
  }, "With Gainsight ", _constants.PLATFORM_BRAND_NAME_POSSESSIVE_FORM, " Salesforce integrations, you can:"), (0, _preact.h)("div", {
    className: "description-details"
  }, (0, _preact.h)("ul", null, (0, _preact.h)("li", null, "Export community member and activity data to Salesforce to get a 360 view of your customers, enable custom engagement workflows, and perform advanced community reporting."), (0, _preact.h)("li", null, "Import Salesforce account data to ", _constants.PLATFORM_BRAND_NAME, " to measure your monthly active customers on the engagement dashboard."), (0, _preact.h)("li", null, "Streamline your support workflow by creating Salesforce Cases from community posts on ", _constants.PLATFORM_BRAND_NAME, "."), (0, _preact.h)("li", null, "Increase self-service by displaying Salesforce knowledge base articles for end users in the", ' ', _constants.PLATFORM_BRAND_NAME, " search results."), (0, _preact.h)("li", null, "This integration ", (0, _preact.h)("b", null, "requires installing the Salesforce package"), " from AppExchange."))));
};

var _default = SalesforceIntegration;
exports.default = _default;